export default ".active-orange-button{color:#ff5722;border-color:#ff5722}.info-popup-text{font-size:17px}";